export const stringSorter = field => (a, b) =>
  typeof a[field] === 'string' && typeof b[field] === 'string'
    ? a[field].localeCompare(b[field])
    : a[field];
